import React from 'react';
import { FiZap } from 'react-icons/fi';

/**
 * LightningIcon
 * Ikona blesku pre označenie rýchlych alebo prioritných akcií.
 */
const LightningIcon = ({ className = 'inline-block align-middle', ...props }) => (
  <FiZap className={className} {...props} />
);

export default LightningIcon;

